import { render, staticRenderFns } from "./ComposicaoDoRebanhoMedioPorCabecaAbsoluto.vue?vue&type=template&id=2df8279e&scoped=true&"
import script from "./ComposicaoDoRebanhoMedioPorCabecaAbsoluto.vue?vue&type=script&lang=js&"
export * from "./ComposicaoDoRebanhoMedioPorCabecaAbsoluto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df8279e",
  null
  
)

export default component.exports